import React, { useState } from "react";
import PageHero from "@/components/shared/PageHero";
import { FormShell, SuccessPopup } from "@/components/shared/FormShell";
import { CATEGORIES } from "@/data/mock";
import { Upload, Sparkles } from "lucide-react";

export default function ShareIdeas() {
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ category: "", title: "", description: "" });
    const code = "IDEA-2026-" + Math.floor(100000 + Math.random() * 900000);
    return (
        <>
            <PageHero
                testId="share-ideas-page"
                eyebrow="Share Ideas"
                chapter="Service · 03"
                title="Share an idea."
                subtitle="Great policy is a great idea, executed patiently. Tell us what could be, and we'll route it to a discovery pipeline."
            />
            <FormShell
                aside={
                    <div>
                        <div className="eyebrow mb-4">How ideas travel</div>
                        <ol className="space-y-4 text-[14px] leading-relaxed text-slate-600">
                            <li><span className="serif-italic mr-2 text-pink">01.</span> Submitted to Ideas cell</li>
                            <li><span className="serif-italic mr-2 text-pink">02.</span> Reviewed by domain experts</li>
                            <li><span className="serif-italic mr-2 text-pink">03.</span> Shortlisted for prototyping</li>
                            <li><span className="serif-italic mr-2 text-pink">04.</span> Ideator invited to co-create</li>
                        </ol>
                        <div className="mt-6 flex items-start gap-3 rounded-2xl border border-ink/10 bg-white p-4 text-[13px] text-slate-500">
                            <Sparkles className="mt-0.5 h-4 w-4 text-pink" />
                            The best ideas are simple, specific, and made better by a story. Include one.
                        </div>
                    </div>
                }
            >
                <form className="space-y-8" onSubmit={(e) => { e.preventDefault(); setOpen(true); }} data-testid="ideas-form">
                    <div className="field">
                        <label>Category</label>
                        <select required value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} data-testid="idea-category">
                            <option value="">Select category</option>
                            {CATEGORIES.ideas.map((c) => <option key={c} value={c}>{c}</option>)}
                        </select>
                    </div>
                    <div className="field">
                        <label>Title</label>
                        <input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="Give your idea a memorable name" data-testid="idea-title" />
                    </div>
                    <div className="field">
                        <label>Description</label>
                        <textarea rows={7} required value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} placeholder="What's the idea? What problem does it solve? Who benefits?" data-testid="idea-description" />
                    </div>
                    <div className="field">
                        <label>Upload supporting document</label>
                        <label className="mt-2 flex cursor-pointer items-center justify-between rounded-2xl border border-dashed border-ink/20 bg-slate-50 px-6 py-6 text-[13px] text-slate-500 hover:border-pink hover:text-pink transition-colors">
                            <span className="flex items-center gap-3"><Upload className="h-4 w-4" /> PDF, deck or reference (UI only)</span>
                            <span className="text-[10px] uppercase tracking-[0.24em]">Optional</span>
                            <input type="file" className="hidden" data-testid="idea-upload" />
                        </label>
                    </div>
                    <div className="flex items-center gap-4 pt-4">
                        <button type="submit" className="btn-primary" data-testid="idea-submit">Submit idea</button>
                    </div>
                </form>
            </FormShell>
            <SuccessPopup open={open} onClose={() => setOpen(false)} title="Idea submitted" body="Thanks for contributing. Great ideas will be featured on the platform's public wall." code={code} />
        </>
    );
}
